import { createContext } from 'react';
import { PriceInterval } from 'shared/types/price';

export type PremiumDialogContextProps = {
  openPremiumDialog: (priceInterval?: PriceInterval) => void;
};

export const PremiumDialogContext = createContext<PremiumDialogContextProps>({
  openPremiumDialog: () => {},
});
